// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://explorer.zksync.io/address/0x0a902bCd36F128683EAF1eE7001a3ad2E808d93B
export const TRANSPARENT_PROXY_FACTORY = '0x0a902bCd36F128683EAF1eE7001a3ad2E808d93B';

// https://explorer.zksync.io/address/0x158d6c497317367CEa3CBAb0BD84E6de236F060D
export const PROXY_ADMIN = '0x158d6c497317367CEa3CBAb0BD84E6de236F060D';

// https://explorer.zksync.io/address/0xba845c27903F7dDB5c676e5b74728C871057E000
export const PROTOCOL_GUARDIAN = '0xba845c27903F7dDB5c676e5b74728C871057E000';

export const CHAIN_ID = 324;
